<template>
  
    <!--startprint-->
    <div>
      <div id="pdfDom" ref="exportPdf" class="talentCard">
      <div class="title">TALENT CARD</div>
      <Row class="personalData" :gutter="20">
        <Col span="3" class="left">
          <img v-if="infoItem.portrait" :src="'data:image/jpeg;base64,' + infoItem.portrait || ''" />
            <img v-else src="@/assets/headerImg.png" />
        </Col>
        <Col span="21" class="right">
          <div class="title redBg">{{$t('Basic_Information')}}</div>
          <div class="content">
            <Row class="mgTo5 ">
              <Col span="8" >
                <Row class="h53" >
                  <Col class="lable  padTo10" span="10">{{$t('Name')}}:</Col>
                  <Col class="value  padTo10" span="13">{{infoItem.userName}}</Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h53">
                  <Col class="lable  padTo10" span="10">{{$t('Job_Title')}}:</Col>
                  <Col class="value  padTo10" span="13">{{lang=='zh'?infoItem.positionChName:infoItem.positionEnName}}</Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h25">
                  <Col class="lable  padTo3" span="10">{{$t('Line_Manager')}}:</Col>
                  <Col class="value  padTo3" span="13"> {{infoItem.dirUserName}}</Col>
                </Row>
                <Row class="h25 mgTo5">
                  <Col class="lable  padTo3" span="10">{{$t('Dotted-Line_Manager')}}:</Col>
                  <Col class="value  padTo3" span="13">{{infoItem.indirUserName}} </Col>
                </Row>
              </Col>
            </Row>
            <Row class="mgTo5">
              <Col span="8">
                <Row class="h30">
                  <Col class="lable  padTo6" span="10">{{$t('Nationality_PPT')}}:</Col>
                  <Col class="value  padTo6" span="13">{{lang=='zh'?infoItem.chNationality:infoItem.enNationality}}</Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h30">
                  <Col class="lable  padTo6" span="10">{{$t('Band')}}:</Col>
                  <Col class="value  padTo6" span="13">{{infoItem.hrgrade}} </Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h30">
                  <Col class="lable padTo6" span="10">{{$t('Mobility_Cross-Team_or_Cross-Function')}}:</Col>
                  <Col class="value  padTo6" span="13">{{lang=='zh'?infoItem.crossFunChName:infoItem.crossFunEnName}} </Col>
                    <!--<Col class="value padTo6" span="13" >
                    <div v-for="(item,index) in infoItem.crossFunList" :key="index">{{lang=='zh'?item.c_name:item.e_name}}</div>
                   <div>Chinese (Native)</div> 
                  </Col>-->
                
                </Row>
              </Col>
            </Row>
            <Row class="mgTo5">
              <Col span="8">
                <Row class="h53">
                  <Col class="lable padTo6" span="10"> {{$t('Date_of_Birth')}}:<span class="dateTextStyle" >(DD/MM/YYYY)</span></Col>
                  <Col class="value padTo6" span="13">{{infoItem.birthday}}</Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h53">
                  <Col class="lable padTo6" span="10">{{$t('Funciton')}}:</Col>
                   <Col class="value padTo6" span="13">{{lang=='zh'?infoItem.functionCName:infoItem.functionEName}}</Col> 
                </Row>
              </Col>
              <Col span="8">
                <Row class="h53">
                  <Col class="lable padTo6" span="10">{{$t('Readiness_for_Next_Position')}}:</Col>
                  <Col class="value padTo6" span="13"> {{lang=='zh'?infoItem.nextJobChName:infoItem.nextJobEnName}}</Col>
                </Row>
              </Col>
            </Row>
            <Row class="mgTo5">
              <Col span="8">
                <Row class="h78">
                  <Col class="lable padTo10" span="10">{{$t('Location_PPT')}}:</Col>
                  <Col class="value padTo10" span="13">{{lang=='zh'?infoItem.districtChName:infoItem.districtEnName}}</Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h37">
                  <Col class="lable padTo3" span="10">
                    {{$t('In position since')}}:<span class="dateTextStyle">(DD/MM/YYYY)</span></Col>
                  <Col class="value padTo3" span="13">{{infoItem.changedate}} </Col>
                </Row>
                <Row class="h37 mgTo5">
                  <Col class="lable padTo3" span="10">{{$t('In_Carlsberg_since_PPT')}}:<span class="dateTextStyle">(DD/MM/YYYY)</span></Col>
                  <Col class="value padTo3" span="13">{{infoItem.hirevalid}} </Col>
                </Row>
              </Col>
              <Col span="8">
                <Row class="h37">
                  <Col class="lable padTo6" span="10"> {{$t('Releasibility_')}}:</Col>
                  <Col class="value padTo6" span="13">{{lang=='zh'?infoItem.releaseChName:infoItem.releaseEnName}} </Col>
                </Row>
                <Row class="h37 mgTo5">
                  <Col class="lable padTo6" span="10">{{$t('Language_s')}}:</Col>
                  <Col class="value padTo6" span="13">{{lang=='zh'?infoItem.chLanguage:infoItem.enLanguage}} </Col>
                  <!--<Col class="value padTo6" span="13" >
                    <div v-for="(item,index) in infoItem.languageList" :key="index">{{lang=='zh'?item.chLanguage:item.enLanguage}}</div>
                     <div>Chinese (Native)</div> 
                  </Col>-->
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row class="h53 performanceAndpotentialStyle">
        <Col span="4" class="redBg title">{{$t('PERFORMANCE_PPT')}}</Col>
        <Col span="4">
          <div class="redBg lable"><!-- WHAT Assessment -->{{$t('WHAT_Assessment_PPT')}} {{Number(year)}}</div>
          <div class="value">{{lang=='zh'?infoItem.chWhatScore:infoItem.whatScore}}</div>
        </Col>
        <Col span="4">
          <div class="redBg lable"><!-- HOW Assessment -->{{$t('HOW_Assessment_PPT')}} {{Number(year)}}</div>
          <div class="value">{{lang=='zh'?infoItem.chHowScore:infoItem.howScore}}</div>
        </Col>
        <Col span="4">
          <div class="redBg lable"><!-- OVERALL Assessment -->{{$t('Overall_Assessment_PPT')}} {{Number(year)}}</div>
          <div class="value">{{lang=='zh'?infoItem.chWholeScore:infoItem.wholeScore}}</div>
        </Col>
        <Col span="4">
          <div class="redBg lable"><!-- OVERALL Assessment -->{{$t('Overall_Assessment_PPT')}} {{Number(year)-1}}</div>
          <div class="value">{{lang=='zh'?infoItem.chLastWholeScore:infoItem.lastWholeScore}}</div>
        </Col>
        <Col span="4">
          <div class="redBg lable"><!-- OVERALL Assessment -->{{$t('Overall_Assessment_PPT')}} {{Number(year)-2}}</div>
          <div class="value">{{lang=='zh'?infoItem.chAgoWholeScore:infoItem.agoWholeScore}}</div>
        </Col>
      </Row>
      <Row class="h53 performanceAndpotentialStyle" style="margin-top: 10px;">
        <Col span="4" class="redBg title">{{$t('POTENTIAL_PPT')}} </Col>
        <Col span="4">
          <div class="redBg lable"><!-- Potential -->{{$t('POTENTIAL_PPT')}} {{Number(year)}}</div>
          <div class="value">{{lang=='zh'?infoItem.chPotentialScore:infoItem.potentialScore}}</div>
        </Col>
        <Col span="4">
          <div class="redBg lable"><!-- Potential -->{{$t('POTENTIAL_PPT')}} {{Number(year)-1}}</div>
          <div class="value">{{lang=='zh'?infoItem.chLastPotentialScore:infoItem.lastPotentialScore}}</div>
        </Col>
        <Col span="4">
          <div class="redBg lable"><!-- Potential -->{{$t('POTENTIAL_PPT')}} {{Number(year)-2}}</div>
          <div class="value">{{lang=='zh'?infoItem.chAgoPotentialScore:infoItem.agoPotentialScore}}</div>
        </Col>
        <Col span="4" >
          <div class="redBg lable">{{$t('Talent_Pool')}}</div>
          <Col class="value" >
            <!--<div v-for="(item,index) in infoItem.talentPoolList" :key="index"> {{lang=='zh'?item.c_name:item.e_name}} </div> {{lang=='zh'?infoItem.talentPoolChName:infoItem.talentPoolEnName}} -->
          </Col>
        </Col>
        <Col span="4">
          <div class="redBg lable">{{$t('Target_Position')}}</div>
          <div class="value" >{{infoItem.targetPosition}}</div>
          <!-- <Col class="value" >
            <div v-for="(item,index) in infoItem.targetPosition" :key="index">{{lang=='zh'?item.name:item.name}}</div>
             <div>Chinese (Native)</div> -->
          <!-- </Col>  -->
        </Col>
      </Row>
      <Row class="careerAnddevelopStyle">
        <div class="career">
          <div class="title redBg">{{$t('CAREER_PROFILE')}}</div>
          <Row style="width: 100%;">
            <div class="lable">{{$t('Work_Experience_Carlsberg')}}:
              <div class="derc">(start - end date: Position)</div>
            </div>
            <div class="value">
              <div class="valueItem" v-for="(item,index) in infoItem.carlsbergList" :key="index"> {{item.name}} </div>
            </div>
          </Row>
          <Row style="width: 100%;">
            <div class="lable">{{$t('Prior_Employment_PPT')}}:
              <div class="derc">(start - end date: Position (Company))</div>
            </div>
            <div class="value">
              <div class="valueItem" v-for="(item,index) in infoItem.lastWork" :key="index"> {{item.name}}</div>
            </div>
          </Row>
          <Row style="width: 100%;">
            <div class="lable"> {{$t('Education_Background')}}:
              <div class="derc">(Institute, Degree, Topic)</div>
            </div>
            <div class="value">
              <div class="valueItem" v-for="(item,index) in infoItem.educationList" :key="index"> {{item.name}}</div>
            </div>
          </Row>
          <Row style="width: 100%;">
            <div class="lable"> {{$t('Career_Aspirations')}}:</div>
            <div class="value">
              <div class="valueItem"> {{infoItem.careerIdeal}} </div>
            </div>
          </Row>
        </div>
        <div class="develop ">
          <div class="title redBg">{{$t('DEVELOPMENT_PLAN_PPT')}}</div>
          <Row style="width: 100%;">
            <div class="lable">{{$t('Development_Objectives')}}:
              <div class="derc">{{infoItem.leftObjective}}</div>
            </div>
            <div class="lable">{{$t('Development_Objectives')}}:
              <div class="derc">{{infoItem.rightObjective}}</div>
            </div>
          </Row>
          <Row style="width: 100%;">
            <div class="value">{{$t('Detailed_Description')}}:
              <div class="derc">
                {{infoItem.leftDetails}}
              </div>
            </div>
            <div class="value">{{$t('Detailed_Description')}}:
              <div class="derc">
                {{infoItem.rightDetails}}
              </div>
            </div>
          </Row>
          <Row style="width: 100%;">
            <div class="value">{{$t('Employee_s_comments')}}:
              <div class="derc">
                {{infoItem.leftEmpDetails}}
              </div>
            </div>
            <div class="value">{{$t('Employee_s_comments')}}:
              <div class="derc">
                {{infoItem.rightEmpDetails}}
              </div>
            </div>
          </Row>
          <Row style="width: 100%;">
            <div class="value">{{$t('Manager_s_Comments')}}:
              <div class="derc">{{infoItem.leftDirFeedBack}}</div>
            </div>
            <div class="value">{{$t('Manager_s_Comments')}}:
              <div class="derc">{{infoItem.rightDirFeedBack}}</div>
            </div>
          </Row>
        </div>
      </Row>
      <!-- <div class="footerText">
        <div>Created on 23/5/2022</div>
        <div>
          <span style="font-weight: blod;">*Mobility: </span> A) Global, B) Regional, C) Within Country (Applies to China, Russia, India), D) 
          Not mobile at current, but aspire to global assignment in future, E)
          Mobile for Short Term Assignment, F) Willing to travel up to 50% in job, G) Not mobile
        </div>
      </div> -->
      
    </div>
    <Spin size="large" fix v-if="spinShow"> </Spin>
      <div v-if="buttonShow">
        <Button type="primary" style="margin-top:15px" @click="getPDF()"><!-- 导出PDF -->{{$t('PB_Export_PDF')}}</Button>
        <Button type="primary" style="margin-top:15px" @click="getPPT()"><!-- 导出PPT -->{{$t('PB_Export_PPT')}}</Button>
        <!-- 上线先隐藏修改按钮 -->
        <Button type="primary" style="margin-top:15px" v-if="btnShow" @click="linkPage()">{{$t('修改')}}</Button>
        <Button v-if="!this.$route.query.empFlag" type="primary" style="margin-top:15px" @click="returnPage()"><!-- 返回 -->{{$t('Return')}}</Button>
      </div>
     
    </div>
    
    <!--endprint-->
</template>
<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      PrintPop: true,
      spinShow:false,
      infoItem:{},
      serialnumber:'',
      buttonShow:true,
      btnShow:true,
      year:'',
      // JSON.parse(sessionStorage.getItem('userInfo')).year
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    
  },
  //
  mounted(){
    if(this.$route.query.serialnumber && !this.$route.query.id && this.$route.query.tab2 !='1' ){
      // this.serialnumber=this.$route.query.serialnumber
      this.getData(this.$route.query.serialnumber)
      this.btnShow=false
      
    }
    // if(this.$route.query.serialnumber && this.$route.query.id && this.$route.query.beEnd){
    //   this.getData(this.$route.query.serialnumber)
    //   this.btnShow=false
    // }
  },
  methods:{
    getData(val,beEnd){
      this.spinShow=true
      this.serialnumber=val
      axios.post("/talentCard/selectTalentCardInfo", {serialnumber:val,id:this.$route.query.id,beEnd:this.$route.query.beEnd}).then((res) => {
        this.spinShow=false
          if(res){
            this.infoItem=res
            this.year=res.year
          }
      })
    },
    getPDF() {
      this.spinShow=true
      var state=false
      setTimeout(() => {
          state=this.getPdf(this.infoItem.userName +"_"+ this.$t('PB_Talent_Card'))
          if(state){
            this.spinShow=false
          }
      }, 3000);
    },
    getPPT(){
      let data={
        serialnumber:this.serialnumber,
        language:this.lang=='zh'?'1':'0'
      }
      this.spinShow=true
      axios({
        url:'/downloadPPT/action',
        method: 'post',
        data,
        responseType: 'blob'
      }).then(res => {
        this.spinShow=false
        const fileName = this.infoItem.userName +"_"+ this.$t('PB_Talent_Card')+'.pptx'
        // 此处当返回json文件时需要先对data进行JSON.stringify处理，其他类型文件不用做处理
        //const blob = new Blob([JSON.stringify(data)], ...)
        const blob = new Blob([res])
        let dom = document.createElement('a')
        let url = window.URL.createObjectURL(blob)
        dom.href = url
        dom.download = decodeURI(fileName)
        dom.style.display = 'none'
        document.body.appendChild(dom)
        dom.click()
        dom.parentNode.removeChild(dom)
        window.URL.revokeObjectURL(url)
      })
      
    },
    returnPage(){
      if(this.$route.query.serialnumber && !this.$route.query.plan){
        this.$router.back()        
      }else {
        this.$emit('back',false)
      }
      
    },
    linkPage(){
      this.$router.push({ path: '/E97C32785C9AE390D144654FAD9065F232F121EF19EC8484/A3FFBEBFDB713E27', query: { id: this.serialnumber } })
    }
  }
};
</script>
<style scoped lang="less">
.talentCard {
  padding: 3px 10px;
  font-size: 18px;
  background-color: #fff;
  color: #000;
  position: relative;

  .footerText {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    line-height: 1.2;
    margin-top: 5px;
    .logo2 {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }
  .title {
    font-size: 24px;
    color: #948253;
    font-weight: bold;
  }

  .h78 {
    height: 78px;
  }
  .h53 {
    min-height: 53px;
    max-height: 100px;
  }
  .h25 {
    height: 25px;
  }
  .h37 {
    height: 37px;
  }
  .h30 {
    height: 30px;
  }
  .mgTo5 {
    margin-top: 5px;
  }
  .padTo10 {
    padding-top: 10px;
  }
  .padTo6 {
    padding-top: 6px;
  }
  .padTo3 {
    padding-top: 3px;
  }
  .redBg {
    background-color: #78283a;
    color: #fff;
  }

  .personalData {

    .left {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      img {
        height: 200px;
        border: 1px solid #000000;
        vertical-align: middle;
      }
    }
    .right {
     

      .title {
        height: 34px;
        line-height: 34px;
        color: #fff;
        font-size: 16px;
        padding-left: 5px;
        font-weight: bold;
      }
      .content {
        color: black;

        .lable {
          padding-left: 5px;
          background-color: #c9c9c9;
          font-weight: bold;
          font-size: 13.5px;
          height: auto;
          line-height: 1.2;
          .dateTextStyle {
            font-size: 12px;
            font-weight: 400;
          }
        }
        .value {
          padding-left: 5px;
          margin-left: 5px;
          background-color: #f2f2f2;
          font-size: 12px;
          height: auto;
          line-height: 1.2;
        }
      }
    }
    .right::before {
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      background-color: #78283a;
      margin-bottom: 3px;
    }
  }
  .performanceAndpotentialStyle {
    margin-top: 5px;
    .title {
      font-size: 14px;
      // margin-right: 5px;
      padding: 10px 5px;
    }
    .lable {
      padding: 5px;
      margin-left: 5px;
      font-weight: 400;
      font-size: 13.5px;
      height: 25px;
      line-height: 1.2;
    }
    .value {
      padding-left: 5px;
      margin-top: 5px;
      margin-left: 5px;
      background-color: #f2f2f2;
      font-size: 12px;
      min-height: 30px;
      max-height: 100px;
      line-height: 1.2;
    }
  }
  .careerAnddevelopStyle {
    width: 100%;
    margin-top: 10px;
    .career,
    .develop {
      width: calc(100% / 2);
    }
    .develop {
      padding-left: 5px;
    }
    .career {
      padding-right: 5px;
    }
    .title {
      font-size: 14px;
      padding: 8px 5px;
      height: 36px;
    }
    .lable {
      padding: 8px;
      padding-right: 5px;
      padding-left: 5px;
      margin-top: 5px;
      font-size: 13.5px;
      font-weight: bold;
      line-height: 1.2;
      background-color: #c9c9c9;
      width: calc(100% - 100% / 1.53);
      .derc {
        font-size: 12px;
        font-weight: 400;
      }
    }
    .value {
      padding: 5px;
      margin-top: 5px;
      margin-left: 5px;
      background-color: #f2f2f2;
      font-size: 12px;
      line-height: 1.2;
      width: calc(100% / 1.56);
    }
    .develop {
      .lable {
        width: 49%;
        margin-left: 5px;
      }
      .value {
        width: 49%;
        margin-left: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/Component/talentCard.vue